import { render, staticRenderFns } from "./ProductsPerSaleAverageIndicator.vue?vue&type=template&id=31ef4bf7&scoped=true"
import script from "./ProductsPerSaleAverageIndicator.vue?vue&type=script&lang=js"
export * from "./ProductsPerSaleAverageIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef4bf7",
  null
  
)

export default component.exports